import * as Types from 'src/actions/filled-test/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import {
  FilledAptitudeTestResponse,
} from 'src/services/api-client/resource/FilledAptitudeTestResource';

export interface GetLatestFilledAptitudeTestAttempt extends Action {
  type: Types.GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT;
}

export interface GetLatestFilledAptitudeTestSuccess extends Action {
  type: Types.GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS;
  payload: FilledAptitudeTestResponse;
}

export interface GetLatestFilledAptitudeTestFailure extends Action {
  type: Types.GET_LATEST_FILLED_APTITUDE_TEST_FAILURE;
  payload: {};
}

export type GetLatestFilledAptitudeTestAction =
  GetLatestFilledAptitudeTestAttempt
  | GetLatestFilledAptitudeTestSuccess
  | GetLatestFilledAptitudeTestFailure;

export interface GetLatestFilledAptitudeTestThunk extends
  ThunkAction<Promise<GetLatestFilledAptitudeTestAction>, RootState, null> {
}

export const getLatestFilledAptitudeTestAttempt: ActionCreator<GetLatestFilledAptitudeTestAttempt> = () => (
  {type: Types.GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT}
);

export const getLatestFilledAptitudeTestSuccess: ActionCreator<GetLatestFilledAptitudeTestSuccess> = (
  successPayload: FilledAptitudeTestResponse
) => (
  {
    type: Types.GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS,
    payload: successPayload
  }
);

export const getLatestFilledAptitudeTestFailure: ActionCreator<GetLatestFilledAptitudeTestFailure> = (error: {}) => (
  {
    type: Types.GET_LATEST_FILLED_APTITUDE_TEST_FAILURE,
    payload: error
  }
);

export const getLatestFilledAptitudeTest: ActionCreator<GetLatestFilledAptitudeTestThunk> = (
  personId: number, personType: string): GetLatestFilledAptitudeTestThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetLatestFilledAptitudeTestAction> => {
    dispatch(getLatestFilledAptitudeTestAttempt());

    return ApiClient.filledAptitudeTest.getLatest({personId: personId, personType: personType})
      .then((response: AxiosResponse<FilledAptitudeTestResponse>): GetLatestFilledAptitudeTestSuccess => {

        const successPayload: FilledAptitudeTestResponse = response.data;

        return dispatch(getLatestFilledAptitudeTestSuccess(successPayload));
      }).catch((e: { response: { data: { error: Error } } }): GetLatestFilledAptitudeTestFailure => {
        const errorMessages = e && e.response && e.response.data && e.response.data.error || {
          serverConnection: 'Error en la conexión, por favor inténtelo más tarde'
        };
        return dispatch(getLatestFilledAptitudeTestFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/filled-test/get/GetLatestFilledAptitudeTest.actions.tsx